import { jsx as _jsx } from "react/jsx-runtime";
import { LoadingOutlined } from '@ant-design/icons';
import { Button, Spin, Tooltip } from 'antd';
import { txt } from 'libs/i18n';
import { useState } from 'react';
import { useAppContext, screenBreakpoints } from 'App/app-context';
import clsx from 'clsx';
import styles from './style.module.less';
const SecondaryActionButton = ({ onAction, title, icon, disabled, id, async = false, loadingMessage = txt('loading'), className, size = 'small', displayTextOnSmallScreen = false, breakpoint = screenBreakpoints.xl, }) => {
    const [isLoading, setIsLoading] = useState(false);
    const { screenSize } = useAppContext();
    const showLabel = screenSize.width >= breakpoint
        || (icon === undefined || displayTextOnSmallScreen);
    const handleAsyncAction = async () => {
        if (onAction === undefined) {
            return;
        }
        setIsLoading(true);
        await onAction();
        setIsLoading(false);
    };
    const button = (_jsx(Button, { id: id, onClick: async ? handleAsyncAction : onAction, size: size, className: clsx(styles.secondaryButton, className), disabled: disabled === true || isLoading, icon: isLoading ? (_jsx(Spin, { size: "small", className: styles.spinnerIcon, indicator: _jsx(LoadingOutlined, {}) })) : (icon), children: showLabel && (_jsx("span", { children: isLoading ? loadingMessage : title })) }));
    return showLabel ? button : _jsx(Tooltip, { title: title, children: button });
};
export default SecondaryActionButton;
